import axios from 'axios';
export default axios.create({
    //@ts-ignore
    headers: { 'X-Requested-With': 'XMLHttpRequest', 'X-CSRF-TOKEN': window.csrf_token },
    //@ts-ignore
    baseURL: window.$domain
    //baseURL: 'http://192.168.6.35:8081'
});
